export default "__VITE_ASSET__b9cfbc6b__"